import React from "react";
import { CheckCircle2, Circle, Package, CreditCard, UserCheck, Truck, MapPin } from "lucide-react";

const ICONS = {
  pending_payment: CreditCard,
  paid: CheckCircle2,
  assigned: UserCheck,
  picked_up: Package,
  in_transit: Truck,
  delivered: MapPin,
};

function fmt(ts) {
  try { return new Date(ts).toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }); }
  catch { return ts; }
}

export default function TrackingTimeline({ history }) {
  const items = [...(history || [])].reverse();
  return (
    <ol className="relative space-y-0" data-testid="tracking-timeline">
      {items.map((h, i) => {
        const Icon = ICONS[h.status] || Circle;
        const isLatest = i === 0;
        return (
          <li key={`${h.status}-${h.timestamp || i}`} className="relative flex gap-4 pb-6 last:pb-0">
            {i !== items.length - 1 && <span className="absolute left-[15px] top-8 h-full w-0.5 bg-border" />}
            <div className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full ${isLatest ? "bg-kilted-green text-white" : "bg-secondary text-muted-foreground"}`}>
              <Icon className="h-4 w-4" />
            </div>
            <div className="pt-0.5">
              <p className={`text-sm font-semibold capitalize ${isLatest ? "text-kilted-green" : "text-foreground"}`}>
                {h.status.replace("_", " ")}
              </p>
              <p className="text-sm text-muted-foreground">{h.note}</p>
              <p className="mt-0.5 text-xs text-muted-foreground/70">{fmt(h.timestamp)}</p>
            </div>
          </li>
        );
      })}
    </ol>
  );
}
